import React from 'react';
import classNames from 'classnames';
import styles from './styles.module.scss';
import {Draggable} from '@priority-software/priority-style-react';
import {FormData} from '../DialogHeader';
import {InjectedDraggableProps} from '../../../../components/Common/DraggableList';
import {ListItem} from './ListItem';

type ItemProps = {
    index: number;
    totalSelected: number;
    toggleChecked: (entityId: string, isChecked: boolean) => void;
} & FormData &
    InjectedDraggableProps;

export const ShownForm = (props: ItemProps) => {
    const {entityId, toggleChecked, formTitle, index, totalSelected, ...draggableProps} = props;
    const notLast = index < totalSelected - 1;
    return (
        <Draggable
            {...draggableProps}
            iconPosition="center"
            key={entityId}
            componentClasses={styles.dragMargin}
        >
            <div
                className={classNames({[styles.borderBottom]: notLast}, styles.padding)}
                onClick={() => toggleChecked(entityId, true)}
            >
                <ListItem formTitle={formTitle} disabled={false} checked={true} />
            </div>
        </Draggable>
    );
};
